import { NOMINATIF_LOADING, GET_NOMINATIF, GET_NOMINATIF_SUCCESS, GET_NOMINATIF_FAIL, ADD_NOMINATIF_SUCCESS, ADD_NOMINATIF_FAIL, DELETE_NOMINATIF_SUCCESS, DELETE_NOMINATIF_FAIL, UPDATE_NOMINATIF_SUCCESS, UPDATE_NOMINATIF_FAIL, NOMINATIF_RESET, NOMINATIF_RESET_CREATE } from "./actionType";

const INIT_STATE = {
  nominatifs: [],
  nominatifOne: null,
  nominatifAdded: {},
  error: {},
  isNominatifCreated: false,
};

const Nominatif = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_NOMINATIF_SUCCESS:
      switch (action.payload.actionType) {
        case GET_NOMINATIF:
          return {
            ...state,
            nominatifs: action.payload.data,
            isNominatifCreated: false,
            isNominatifSuccess: true,
            loading: false,
          };

        default:
          return { ...state };
      }
    case GET_NOMINATIF_FAIL:
      switch (action.payload.actionType) {
        case GET_NOMINATIF_FAIL:
          return {
            ...state,
            error: action.payload.error,
            isNominatifCreated: false,
            isNominatifSuccess: false,
            loading: false,
          };
        default:
          return { ...state };
      }

    case GET_NOMINATIF: {
      return {
        ...state,
        isNominatifCreated: false,
        loading: true,
      };
    }

    case NOMINATIF_LOADING: {
      return {
        ...state,
        isNominatifCreated: false,
        loading: true,
      };
    }

    case ADD_NOMINATIF_SUCCESS:
      return {
        ...state,
        isNominatifCreated: true,
        loading: false,
        nominatifs: [action.payload.data, ...state.nominatifs],
        nominatifAdded: action.payload.data,
      };

    case ADD_NOMINATIF_FAIL:
      return {
        ...state,
        isNominatifCreated: false,
        loading: false,
        error: action.payload,
      };

    case DELETE_NOMINATIF_SUCCESS:
      return {
        ...state,
        loading: false,
        nominatifs: state.nominatifs.filter((nominatif) => nominatif.id.toString() !== action.payload.id.toString()),
      };

    case DELETE_NOMINATIF_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_NOMINATIF_SUCCESS:
      return {
        ...state,
        loading: false,
        isNominatifCreated: true,
        nominatifs: state.nominatifs.map((nominatif) => (nominatif.id.toString() === action.payload.data.id.toString() ? { ...nominatif, ...action.payload.data } : nominatif)),
        nominatifAdded: action.payload.data,
      };

    case UPDATE_NOMINATIF_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case NOMINATIF_RESET:
      return INIT_STATE;

    default:
      return { ...state };
  }
};

export default Nominatif;
